/**
 * Catalogo Eccellenze — patrimonio gastronomico curato (separato da prodotti certificati).
 * @typedef {Object} Eccellenza
 * @property {string} id
 * @property {string} nome
 * @property {string} borgoSlug
 * @property {string} categoria
 * @property {string} sottocategoria
 * @property {string} descrizione
 * @property {string} tradizione
 * @property {string} produttore
 * @property {string} imageUrl
 * @property {string} tutorialVideoUrl
 * @property {number} auraVariantReward
 */

/** @type {Eccellenza[]} */
export const ECCELLENZE_CATALOG = [
  {
    id: "ecc-pizza-dolce-montorio",
    nome: "Pizza Dolce di Montorio",
    borgoSlug: "montorio",
    categoria: "Patrimonio Gastronomico",
    sottocategoria: "dolci",
    descrizione:
      "La Pizza Dolce di Montorio è il dolce stratificato per eccellenza della Valle del Vomano: disco di pasta " +
      "frolla sottile, crema pasticcera, strato di cioccolato e bagne all'Alchermes che tingono di rosso i " +
      "piani di pan di Spagna — infine copertura di panna e mandorle tostate. La stratificazione visibile " +
      "in ogni fetta racconta l'ordine delle mani e il tempo di riposo in frigo. Nel network 6AMICO le " +
      "Varianti Familiari documentano come ogni casa conserva proporzioni e racconti diversi.",
    tradizione:
      "Simbolo delle feste patronali e delle domeniche in famiglia a Montorio al Vomano; la ricetta si " +
      "tramanda oralmente, con l'Alchermes e le mandorle come firma del territorio.",
    produttore: "Tradizione familiare · Montorio al Vomano",
    imageUrl: "/images/eccellenze/pizza-dolce-montorio.jpg",
    tutorialVideoUrl: "https://www.youtube.com/watch?v=1Q8fG0HitpU",
    auraVariantReward: 15,
  },
];

export function getEccellenzaById(id) {
  return ECCELLENZE_CATALOG.find((e) => e.id === id) || null;
}

export function listEccellenze({ borgoSlug } = {}) {
  if (!borgoSlug) return [...ECCELLENZE_CATALOG];
  return ECCELLENZE_CATALOG.filter((e) => e.borgoSlug === borgoSlug);
}
